import type { RecordView } from '@kit/sync/types/record-view';
import { useRecords } from '@/entities/shared/record/use-records';
import type { Task } from '../schemas/task';

export function useTasks(): RecordView<Task>[] | undefined {
  return useRecords<Task>('tasks');
}
